import "../../../../src/content/porto-streaming/porto.scss";
import * as React from 'react';
export default {
  React
};